import { createSelector } from 'reselect'
import { GoogleScopes } from 'app/modules/integrations/constants'

export const root = (state) => state.get('meetings')
export const getMeetingsState = state => state.get('meetings')
export const getDefaultMeetingType = state => state.getIn(['meetings', 'meeting'])
export const getMeetingTypes = state => state.getIn(['meetings', 'meetingTypes'])
export const getMeetingTypeStatus = state => state.getIn(['meetings', 'meetingTypesStatus'])

export const getCalendlyMeetingTypes = state => state.getIn(['meetings', 'calendlyMeetingTypes'])
export const getCalendlyMeetingTypeStatus = state => state.getIn(['meetings', 'calendlyMeetingTypesStatus'])

export const getCalendarStatusFetchStatus = state => getMeetingsState(state).calendarStatusFetchStatus
export const getGoogleCalendarFetchStatus = state => getMeetingsState(state).googleCalendarsFetchStatus
export const getMicrosoftCalendarFetchStatus = state => getMeetingsState(state).microsoftCalendarsFetchStatus

export const getCalendarStatusPending = state => getCalendarStatusFetchStatus(state) === 'pending'
export const getCalendarStatusLoaded = state =>
  getCalendarStatusFetchStatus(state) === 'success' || getCalendarStatusFetchStatus(state) === 'failure'

export const isGoogleCalendarsFetchPending = state => getGoogleCalendarFetchStatus(state) === 'pending'
export const isGoogleCalendarsFetchCompleted = state =>
  getGoogleCalendarFetchStatus(state) === 'success' || getGoogleCalendarFetchStatus(state) === 'failure'

export const isMicrosoftCalendarsFetchPending = state => getMicrosoftCalendarFetchStatus(state) === 'pending'
export const isMicrosoftCalendarsFetchCompleted = state =>
  getMicrosoftCalendarFetchStatus(state) === 'success' || getMicrosoftCalendarFetchStatus(state) === 'failure'

export const hasMicrosoftAdminConsent = state => getMeetingsState(state).microsoftCalendarAdminManaged
export const getMicrosoftAdminConsentUsers = state => getMeetingsState(state).microsoftCalendarAdminIds
export const getIsMicrosoftAdminConsentError = state => getMeetingsState(state).microsoftCalendarAdminError
export const hasFetchedMicrosoftAdminConsent = state => getMeetingsState(state).microsoftCalendarAdminManaged !== undefined
export const isMicrosoftGlobalCalendarsLoading = state => getMeetingsState(state).fetchMicrosoftGlobalCalendarStatus === 'pending'
export const isMicrosoftGlobalCalendarsLoaded = state => getMeetingsState(state).fetchMicrosoftGlobalCalendarStatus === 'success'

export const isFetchMicrosoftAdminConsentLoading = state => getMeetingsState(state).fetchMicrosoftAdminConsentStatus === 'pending'
export const isFetchMicrosoftAdminConsentLoaded = state => getMeetingsState(state).fetchMicrosoftAdminConsentStatus === 'success'

export const isOauthConnected = state => getMeetingsState(state).connected
export const getIsGoogleOauthConnected = state => getMeetingsState(state).googleAuthed
export const getIsGoogleOauthConnectedError = state => getMeetingsState(state).googleAuthedError
export const getIsMicrosoftOauthConnected = state => getMeetingsState(state).microsoftAuthed
export const getIsZoomOauthConnected = state => getMeetingsState(state).zoomAuthed
export const getIsZoomOauthConnectedError = state => getMeetingsState(state).zoomAuthedError
export const getIsTokenRevoked = state => getMeetingsState(state).isTokenRevoked
export const isGoogleOrMicrosoftConnected = state =>
  getIsGoogleOauthConnected(state) || getIsMicrosoftOauthConnected(state) || hasFetchedMicrosoftAdminConsent(state)

export const getCalendar = state => getMeetingsState(state).calendar
export const getCalendars = state => getMeetingsState(state).calendars
export const getGoogleScopes = state => getMeetingsState(state).scopes
export const hasCalendarScope = state => getGoogleScopes(state).includes(GoogleScopes.CALENDAR)
export const hasEmailScope = state =>
  _.some(getGoogleScopes(state), scope => scope === GoogleScopes.SEND || scope === GoogleScopes.READ)

export const getMeetingSettings = state => getMeetingsState(state).meeting
export const getMeetingSettingsStatus = state => getMeetingsState(state).meetingStatus
export const isMeetingSettingsLoaded = state => getMeetingsState(state).meetingStatus === 'success'

export const isMeetingTypesLoaded = state => getMeetingTypeStatus(state) === 'success'
export const isMeetingTypesLoading = state => getMeetingTypeStatus(state) === 'pending'

export const getMeetingTypeBySlug = slug =>
  createSelector(getMeetingTypes, meetingTypes => _.find(meetingTypes, { slug }))

export const getAgentIdsWithConnectedCalendarsStatus = state =>
  getMeetingsState(state).agentIdsWithConnectedCalendarsStatus
export const getAgentIdsWithConnectedCalendars = state =>
  getMeetingsState(state).agentIdsWithConnectedCalendars

export const isAgentIdsWithConnectedCalendarsPending = state => {
  return getAgentIdsWithConnectedCalendarsStatus(state) === 'pending'
}

export const isShareRoutedCalendarLoading = state => {
  return root(state).get('shareRoutedCalendarLoading')
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/meetings/selectors.js